import type { VNode } from 'vue';
import { NCard } from 'naive-ui';

export default defineNuxtComponent({
  name: 'ContentCard',
  render(): VNode {
    return <NCard class="content-card">{this.$slots.default?.()}</NCard>;
  },
});
